import {ImageVM} from "./ImageVM.model";
import {PriceInfoDetailVM} from "./PriceInfoDetailVM.model";
import {ServiceOptionVM} from "./ServiceOptionVM.model";
import {TotalPriceVM} from "./TotalPriceVM.model";
import {PersonInfoVM} from "./PersonInfoVM.model";
import {OrderBagItemVM} from "./OrderBagItemVM.model";
import {CompanyCustomerVM} from "./CompanyCustomerVM.model";
/**
 * Created by saeed on 12/29/2016.
 */

export class OrderBagVM {
  id:number;
  orderBagServiceItems:OrderBagItemVM[] = [];
  status;
  inPlacePayment:boolean;
  comment:string;
  finalPrice:number;
  onlinePaymentAmount:number;
  imageAlbum;
  coverImage;
  orderbagid;
  serviceTitle;
  intakeData;
  couponToCheckValidity:number;
  companyCustomer : CompanyCustomerVM;
  originReturnUrl;

  constructor() {

  }

  static calculateTotalPrice(orderBag:OrderBagVM):TotalPriceVM {
    let total:TotalPriceVM = new TotalPriceVM();
    orderBag.orderBagServiceItems.forEach(function (item) {
      if (item)
        total.subtotalServicePrice += item.totalPrice.subtotalServicePrice;
      total.totalRowPrice += item.totalPrice.totalRowPrice;
      total.subtotalDiscount += item.totalPrice.subtotalDiscount;
      total.subtotalVAT += item.totalPrice.subtotalVAT;
      total.subtotalOptionPrice += item.totalPrice.subtotalOptionPrice;
      total.prePaymentAmount += item.totalPrice.prePaymentAmount;
      if (item.totalPrice.prePaymentAmount) {

        total.onlinePaymentAmount += item.totalPrice.prePaymentAmount;
        total.payInPersonAmount += item.totalPrice.totalRowPrice - item.totalPrice.prePaymentAmount;
      }
      else
        total.onlinePaymentAmount += item.totalPrice.totalRowPrice;
    });
    return total;
  }
}
export enum OrderBagStatus
{
  ACTIVE = 0,
  CONFIRMED = 1,
  EXPIRED = 2,
  DELETED = 3,
  CANCELED = 4,
  RESERVE_REQUEST = 5,
  REQUEST_CONFIRMED = 6
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/models/OrderBagVM.model.ts